import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Also attach bearer token if we saved one in localStorage as a fallback (for cross-domain cookie edge cases)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("itzkatu_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default api;

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
